import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import ApplicationLayout from '../../../layouts/ApplicationLayout';
import TapIcon from '../../../services/TapIcon';
import { useSelector } from 'react-redux';
import HttpAPICall from '../../../services/HttpAPICall';
import Loader from '../../../components/ui/Loader/Loader';
import { toast } from 'react-toastify';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import TapSelect from '../../../components/ui/TapSelect';
import DatePicker from "react-datepicker";
import moment from 'moment';

const AddDeviceDataListing = ({ history, location }) => {
    const access_token = useSelector(state => state.auth.access_token);
    const [submitLoading, setSubmitLoading] = useState(false)
    const [loading, setLoading] = useState(false)
    const [manufacturerData, setManufacturerData] = useState([])
    const [deviceTypeData, setDeviceTypeData] = useState([])
    const [allModels, setAllModels] = useState([])
    const [filteredModels, setFilteredModels] = useState([])
    const [formData, setFormData] = useState({
        id: "",
        device_id: "",
        manufacturer_id: "",
        modal_id: "",
        imei_no: "",
        device_type_id: "",
        product_serial_no: "",
        manufacturer_device_id :"" ,
        date_of_purchase: "",
        invoice_no: "",
        notes: ""
    })
    const [isEditMode, setIsEditMode] = useState(false)

    const getFormData = () => {
        setLoading(true)
        HttpAPICall.withAthorization('GET', BACKOFFICE_BASE_URL + '/device_form_data', access_token, {}, {}, (resp) => {
            const respData = resp.data
            setManufacturerData(respData?.manufacturers && respData.manufacturers.map(mf => ({ label: mf.name, value: mf.id })))
            setDeviceTypeData(respData?.device_types && respData.device_types.map(mf => ({ label: mf.name, value: mf.id })))
            if (respData?.models) {
                setAllModels(respData.models.map(model => ({
                    label: model.name,
                    value: model.id,
                    manufacturer_id: model.manufacturer_id
                })))
            }
        }).then(() => setLoading(false));
    }
    useEffect(() => {
        if (formData.manufacturer_id) {
            const filtered = allModels.filter(model =>
                model.manufacturer_id === Number(formData.manufacturer_id)
            );
            setFilteredModels(filtered);

            const currentModel = allModels.find(m => m.value === formData.modal_id);
            if (currentModel && currentModel.manufacturer_id !== Number(formData.manufacturer_id)) {
                setFormData(prev => ({ ...prev, modal_id: "" }));
            }
        } else {
            setFilteredModels([]);
            if (formData.modamodal_idl) {
                setFormData(prev => ({ ...prev, modal_id: "" }));
            }
        }
    }, [formData.manufacturer_id, allModels]);

    const backToListing = () => {
        history.push({ pathname: '/device' });
    }

    useEffect(() => {
        initialFormData()
    }, []);

    const tapSelectChange = (selectedOption, formKey) => {
        setFormData(prev => ({
            ...prev,
            [formKey]: selectedOption ? Number(selectedOption.value) : ""
        }));
    };


    const initialFormData = () => {
        getFormData();

        if (location?.state?.editdeviceDataListing) {
            const editData = location.state?.editdeviceDataListing;
            console.log(editData);

            setFormData({
                id: editData.id || "",
                device_id: editData.device_id || "",
                manufacturer_id: editData?.manufacturer?.id || "",
                modal_id: editData.modal?.id || "",
                imei_no: editData.imei_no || "",
                device_type_id: editData.device_type?.id || "",
                product_serial_no: editData.product_serial_no || "",
                manufacturer_device_id : editData.manufacturer_device_id || "",
                date_of_purchase: editData.date_of_purchase
                    ? new Date(editData.date_of_purchase)
                    : "",
                invoice_no: editData.invoice_no || "",
                notes: editData.notes || ""
            });
            if (editData?.manufacturer?.id) {
                setTimeout(() => {
                    const filtered = allModels.filter(model =>
                        model.manufacturer_id === Number(editData.manufacturer.id)
                    );
                    setFilteredModels(filtered);
                }, 100);
            }


            setIsEditMode(true);
        }
    };

    const handleDateTimeChange = (value) => {
        setFormData(prev => ({
            ...prev,
            date_of_purchase: value
        }));
    };

    const submitDataForm = (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            date_of_purchase: formData.date_of_purchase
                ? moment(formData.date_of_purchase).format("YYYY-MM-DD")
                : ""
        };

        setSubmitLoading(true);

        if (isEditMode) {
            HttpAPICall.withAthorization('PUT', BACKOFFICE_BASE_URL + '/device_edit', access_token, {}, payload, (resp) => {
                toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                history.push({ pathname: '/device', state: { id: formData.id } });

            }
            ).then(() => setSubmitLoading(false));
        } else {
            HttpAPICall.withAthorization(
                'POST', BACKOFFICE_BASE_URL + '/device_add', access_token, {}, payload, (resp) => {
                    toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
                    backToListing();
                }
            ).then(() => setSubmitLoading(false));
        }
    };

    const formInputHandler = (e) => {
        setFormData(pre => ({ ...pre, [e.target.name]: e.target.value }));
    };

    const formDatajsx = () => {
        return (
            <>
                <form className="bg-white p-3" onSubmit={submitDataForm} id="saveResourceForm">
                    {loading ? <Loader />
                        :
                        <>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Device Id</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="device_id"
                                        type="text"
                                        value={formData.device_id}
                                        className="form-control"
                                        autoComplete="off"
                                        required={true}
                                        onChange={formInputHandler}
                                        placeholder="Please enter Device Id"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Device Type</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <TapSelect
                                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'device_type_id')}
                                        options={deviceTypeData}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={deviceTypeData.find(
                                            s => formData.device_type_id == s.value
                                        )}
                                        placeholder={"Please Select Device Type"}
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Icmei</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="imei_no"
                                        type="text"
                                        value={formData.imei_no}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Icmei"
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label require">Manufacturer</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <TapSelect
                                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'manufacturer_id')}
                                        options={manufacturerData}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={manufacturerData.find(
                                            s => formData.manufacturer_id == s.value
                                        )}
                                        placeholder={"Please Select Manufacturer"}
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label">Manufacturer Device Id</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="manufacturer_device_id"
                                        type="text"
                                        value={formData.manufacturer_device_id}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Manufacturer Device Id"

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Model</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <TapSelect
                                        changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'modal_id')}
                                        options={filteredModels}
                                        isSearchable={true}
                                        isClearable={true}
                                        value={filteredModels.find(
                                            s => formData.modal_id == s.value
                                        )}
                                        placeholder={"Please Select Model"}
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label">Product Serial No</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="product_serial_no"
                                        type="text"
                                        value={formData.product_serial_no}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Product Serial no."

                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Invoice No</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="invoice_no"
                                        type="text"
                                        value={formData.invoice_no}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Invoice No"

                                    />
                                </div>
                            </div>
                            
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Date Of Purchase</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <DatePicker
                                        selected={formData.date_of_purchase}
                                        onChange={(value) => handleDateTimeChange(value)}
                                        dateFormat="dd-MMM-yyyy"
                                        className="form-control"
                                        showMonthDropdown
                                        showYearDropdown
                                        autoComplete="off"
                                        scrollMonthYearDropdown
                                        placeholderText="Please Enter Date "
                                    />
                                </div>
                            </div>
                            <div className="row align-items-center my-3">
                                <div className="col-sm-3">
                                    <label htmlFor="path" className="form-label ">Notes</label>
                                </div>
                                <div className="col-sm-8 ">
                                    <input
                                        name="notes"
                                        type="text"
                                        value={formData.notes}
                                        className="form-control"
                                        autoComplete="off"
                                        onChange={formInputHandler}
                                        placeholder="Please enter Notes"

                                    />
                                </div>
                            </div>
                        </>
                    }
                    <div className="col-12 text-end fixed_footer">
                        <button type="button" className="btn btn-secondary mx-3" onClick={backToListing} disabled={submitLoading}>Cancel</button>
                        <button type="submit" className="btn btn-primary mx-2" disabled={submitLoading}>
                            Save {submitLoading ? (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />) : ''}
                        </button>
                    </div>
                </form>
            </>
        );
    };
    const addManufacturerJsx = () => {
        return (
            <>
                <div className="page_title row m0">
                    <div className="col-12">
                        <h3> {isEditMode ? "Edit " : "Add "} Device</h3>
                        <div className="text-end mt15">
                            <>
                                <button type="button" className="btn btn-secondary" onClick={backToListing}>
                                    <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-action" />
                                </button>

                            </>
                        </div>
                    </div>
                </div>
                <div className="container-fluid pl5">
                    <div className="page_containt row">
                        <div className={['pageTbl', 'col-12'].join(' ')}>{formDatajsx()}</div>
                    </div>
                </div>
            </>
        );
    };
    return (
        <ApplicationLayout>
            <Helmet><title>Add Device</title></Helmet>
            {addManufacturerJsx()}
        </ApplicationLayout>
    );
};

export default AddDeviceDataListing;